import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';
import Loadable from 'components/Loadable';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import RootProviders from './RootProviders';
import { SimpleLayoutType } from 'config';
import SimpleLayout from 'layout/Simple/index';

// render - landing page
const PagesLanding = Loadable(lazy(() => import('pages/landing')));
const AboutUsPage = Loadable(lazy(() => import('pages/aboutUs')));
const TermsOfUsePage = Loadable(lazy(() => import('pages/termsOfUse')));
const PrivacyPolicyPage = Loadable(lazy(() => import('pages/privacyPolicy')));

const router = createBrowserRouter(
  [
    // Landing page (no providers needed)
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.LANDING} enableElevationScroll />,
      children: [
        {
          index: true,
          element: <PagesLanding />
        },
        {
          path: 'about-us',
          element: <AboutUsPage />
        },
        {
          path: 'terms-of-use',
          element: <TermsOfUsePage />
        },
        {
          path: 'privacy-policy',
          element: <PrivacyPolicyPage />
        }
      ]
    },
    // App routes (with providers)
    {
      path: '/',
      element: <RootProviders />,
      children: [
        LoginRoutes,
        MainRoutes
      ]
    }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
